import React, { Dispatch, SetStateAction } from "react";
import TableComponent from "../../components/TableComponent";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { ApplicationList } from "../../types/User";
import { PriceFormatter } from "../../utils/commoFunctions";
import { Permission } from "../../types/General";
import {
  APPLICATION_STATUS,
  PAYMENT_STATUS,
  SHOW_APPLICATION_STATUS,
  USER_ROLES,
} from "../../utils/enums";
import useAuth from "../../hooks/useAuth";
import Chip from "../../components/Chip";

type props = {
  selectedId: number | null;
  setSelectedId: Dispatch<SetStateAction<number | null>>;
  rows: ApplicationList[];
  count: number;
  page: number;
  handlePageChange: (event: any, newPage: number) => void;
  loading: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  hidePermission: Permission | undefined;
  applicationStatuses: { [key: number]: string };
  handleApplicationStatus: (
    row: ApplicationList
  ) => (event: SelectChangeEvent) => void;
  setOpenApprovalModal: Dispatch<SetStateAction<boolean>>;
  setSelectedRow: Dispatch<SetStateAction<ApplicationList | null>>;
  selectedRow: ApplicationList | null;
  setOpenCloseApplicationModal: Dispatch<SetStateAction<boolean>>;
};

const TouristVisaApplications = ({
  selectedId,
  setSelectedId,
  rows,
  count,
  page,
  handlePageChange,
  loading,
  hidePermission,
  applicationStatuses,
  handleApplicationStatus,
  setOpenApprovalModal,
  setSelectedRow,
  selectedRow,
  setOpenCloseApplicationModal,
}: props) => {
  const userData = useAuth();
  const navigate = useNavigate();

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    row: ApplicationList
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(row?.id);
    setSelectedRow(row);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
    setSelectedRow(null);
  };
  const applicationStatusData = [
    {
      id: APPLICATION_STATUS.CONSULTATION_ADDED,
      label: SHOW_APPLICATION_STATUS[1],
    },
    {
      id: APPLICATION_STATUS.CONNECT_WITH_VISA_COUNSELLOR,
      label: SHOW_APPLICATION_STATUS[2],
    },
    {
      id: APPLICATION_STATUS.DOCUMENT_VERIFIED,
      label: SHOW_APPLICATION_STATUS[3],
    },
    {
      id: APPLICATION_STATUS.ASSESSMENT,
      label: SHOW_APPLICATION_STATUS[4],
    },
    {
      id: APPLICATION_STATUS.CONTRACT_AND_INITIAL_PAYMENT,
      label: SHOW_APPLICATION_STATUS[5],
    },
    {
      id: APPLICATION_STATUS.CHECKLIST_COMPLETION,
      label: SHOW_APPLICATION_STATUS[6],
    },
    {
      id: APPLICATION_STATUS.FILE_PREPARATION,
      label: SHOW_APPLICATION_STATUS[7],
    },
    {
      id: APPLICATION_STATUS.SCHEDULE_APPOINTMENT,
      label: SHOW_APPLICATION_STATUS[8],
    },
    {
      id: APPLICATION_STATUS.LODGEMENT,
      label: SHOW_APPLICATION_STATUS[9],
    },
    {
      id: APPLICATION_STATUS.REGISTER_IN_EMBASSY,
      label: SHOW_APPLICATION_STATUS[10],
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.5,
      minWidth: 150,
      field: "applicationId",
      headerName: "Id",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.apk_id || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 300,
      field: "name",
      headerName: "Applicant Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img
                src={
                  row?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>
                {row?.first_name || "-"} {row?.middle_name || ""}{" "}
                {row?.last_name || ""}
              </b>{" "}
              {row?.country_code} {row?.phone_no || "-"}
              <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "country",
      headerName: "Country",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.visa_for_country || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentPlan",
      headerName: "Payment Plan",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.payment_plan?.plan_name || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "totalPrice",
      headerName: "Total Price",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {PriceFormatter(row?.payment_plan?.total_price?.toString()) ||
                "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPaid",
      headerName: "Paid Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p> {PriceFormatter(row?.paid_amount?.toString()) || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPending",
      headerName: "Pending Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p> {PriceFormatter(row?.pending_amount?.toString()) || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "approvalStatus",
      headerName: "Approval Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Chip
            label={
              row?.is_closed
                ? "Closed"
                : row?.is_rejected
                  ? "Rejected"
                  : row?.is_verified
                    ? "Approved"
                    : "Pending"
            }
            color={
              row?.is_closed
                ? "#1976D2"
                : row?.is_rejected
                  ? "#D32F2F"
                  : row?.is_verified
                    ? "#4CAF50"
                    : "#FB8C00"
            }
            backgroundColor={
              row?.is_closed
                ? "#E3F2FD"
                : row?.is_rejected
                  ? "#FFEBEE"
                  : row?.is_verified
                    ? "#E8F5E9"
                    : "#FFF3E0"
            }
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "offerLetterStatus",
      headerName: "Offer Letter Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <>
            {row?.payment_status === PAYMENT_STATUS.FIRST_MINIMUM_PAYMENT ? (
              <Chip
                label={row?.employment_letter?.length ? "Sent" : "Pending"}
                color={row?.employment_letter?.length ? "#4CAF50" : "#FB8C00"}
                backgroundColor={
                  row?.employment_letter?.length ? "#E8F5E9" : "#FFF3E0"
                }
              />
            ) : row?.payment_status === PAYMENT_STATUS.FIRST_FULL_PAYMENT ||
              row?.payment_status === PAYMENT_STATUS.SECOND_PAYMENT ||
              row?.payment_status === PAYMENT_STATUS.THIRD_PAYMENT ||
              row?.payment_status === PAYMENT_STATUS.NO_PAYMENT ? (
              row?.employment_letter?.length ? (
                <Chip
                  label={"Sent"}
                  color={row?.employment_letter?.length ? "#4CAF50" : "#FB8C00"}
                  backgroundColor={
                    row?.employment_letter?.length ? "#E8F5E9" : "#FFF3E0"
                  }
                />
              ) : (
                "-"
              )
            ) : (
              "-"
            )}
          </>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "Application Status",
      headerName: "Application Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const currentStatus = Number(applicationStatuses[row.id]) || 0; // Get the current status as a number
        const nextStatus = currentStatus + 1; // Define the next possible status
        return (
          <>
            {!row?.is_verified ? (
              <div className="user_block">
                <p> Not Applicable</p>
              </div>
            ) : (
              <Select
                fullWidth
                labelId="Application Status"
                id={`applicationStatuses-${row.id}`}
                value={applicationStatuses[row.id] || "default"}
                onChange={handleApplicationStatus(row)}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                {applicationStatusData?.map((item) => {
                  return (
                    <MenuItem
                      value={item?.id}
                      key={item?.id}
                      disabled={
                        item?.id <= currentStatus || item?.id > nextStatus
                      }
                      className="menu_disable"
                    >
                      {item?.label}
                    </MenuItem>
                  );
                })}
              </Select>
            )}
          </>
        );
      },
    },

    {
      flex: 0.2,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <>
                    {" "}
                    {selectedRow?.is_rejected ||
                    selectedRow?.is_verified ? null : (
                      <MenuItem
                        disabled={!selectedRow?.extra_documents?.length}
                        onClick={() => {
                          if (selectedId) {
                            setAnchorEl1(null);
                            setOpenApprovalModal(true);
                          }
                        }}
                      >
                        Approval
                      </MenuItem>
                    )}
                  </>
                ) : null}

                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <>
                    {" "}
                    {selectedRow?.is_verified && !selectedRow?.is_closed ? (
                      <MenuItem
                        onClick={() => setOpenCloseApplicationModal(true)}
                      >
                        Close Application
                      </MenuItem>
                    ) : null}
                  </>
                ) : null}

                <MenuItem
                  onClick={() => navigate(`detail/tourist-visa/${selectedId}`)}
                >
                  View
                </MenuItem>

                {selectedRow?.is_rejected || selectedRow?.is_verified ? null : (
                  <MenuItem
                    onClick={() => navigate(`edit/tourist-visa/${selectedId}`)}
                  >
                    Edit
                  </MenuItem>
                )}
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default TouristVisaApplications;
